package co.maytes.standupbot.dashboard.features.settings

import co.maytes.standupbot.dashboard.styles.Motion
import co.maytes.standupbot.dashboard.styles.SettingsClasses
import kotlinx.browser.document
import kotlinx.browser.window
import org.w3c.dom.CENTER
import org.w3c.dom.HTMLElement
import org.w3c.dom.SMOOTH
import org.w3c.dom.ScrollBehavior
import org.w3c.dom.ScrollIntoViewOptions
import org.w3c.dom.ScrollLogicalPosition

object SettingsJump {
    fun to(anchor: String, delayMs: Int = 0) {
        window.setTimeout({ scrollAndFlash(anchor) }, delayMs)
    }

    private fun scrollAndFlash(anchor: String) {
        if (anchor == SettingsCatalog.TOP_ANCHOR) {
            window.scrollTo(0.0, 0.0)
            return
        }
        val row = document.getElementById(settingsAnchorId(anchor)) as? HTMLElement ?: return
        row.scrollIntoView(ScrollIntoViewOptions(behavior = ScrollBehavior.SMOOTH, block = ScrollLogicalPosition.CENTER))
        val panel = row.lastElementChild as? HTMLElement ?: return
        panel.classList.remove(SettingsClasses.FLASH)
        window.setTimeout({ panel.classList.add(SettingsClasses.FLASH) }, FLASH_AFTER_MS)
        window.setTimeout({ panel.classList.remove(SettingsClasses.FLASH) }, Motion.FLASH_MS + FLASH_AFTER_MS)
    }

    private const val FLASH_AFTER_MS = 200
}
